import { render, staticRenderFns } from "./absolute-top-right-btn-text.vue?vue&type=template&id=5e0cd4f4&lang=pug"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports